package org.hs_soft.runmynesto.domain.model.home.customer_card.tabs

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class LoyaltyCardTypeEnum {
    RFID,
    DIGITAL;

    // Composable getter for reactive title
    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            RFID -> strings.rfidCustomerCard
            DIGITAL -> strings.digitalCustomerCard
        }
    }

    // Non-composable getter for static contexts
    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                RFID -> strings.rfidCustomerCard
                DIGITAL -> strings.digitalCustomerCard
            }
        }
}